export default __webpack_public_path__ + "static/media/Shield of Tears Unshed.8eba5f88.jpg";